import { NumberInputBox } from "Components/NumberInputBox";
import { TitleCardsList } from "Components/SelectableCard/Title";
import { Flex, Typography } from "antd";
import { useMemo } from "react";

const englishProficiencyTestOptions = [
  {
    title: "TOEFL",
  },
  {
    title: "IELTS",
  },
  {
    title: "PTE",
  },
];

const testOptions = {
  TOEFL: { placeholder: "Out of 120", maxScore: 120 },
  IELTS: { placeholder: "Out of 9", maxScore: 9 },
  PTE: { placeholder: "Out of 90", maxScore: 90 },
};

export const EnglishProficiencyTest = ({
  selectedCard,
  setSelectedCard,
  scores = {},
  setScores,
}) => {
  const { Title } = Typography;

  const scorePlaceholder = useMemo(() => {
    if (!selectedCard) return "";
    return `${selectedCard} overall score`;
  }, [selectedCard]);

  return (
    <Flex
      vertical
      justify="flex-start"
      align="flex-start"
      style={{ marginTop: "24px" }}
    >
      <Title style={{ fontSize: "18px", textAlign: "left" }}>
        Which English test did you take?
      </Title>
      <Flex wrap>
        <TitleCardsList
          options={englishProficiencyTestOptions}
          selectedCard={selectedCard}
          setSelectedCard={setSelectedCard}
        />
      </Flex>
      {selectedCard && (
        <>
          <Title
            style={{ fontSize: "16px", marginTop: "24px", fontWeight: "500" }}
          >
            {scorePlaceholder}
          </Title>

          <NumberInputBox
            placeholder={testOptions[selectedCard]?.placeholder}
            value={scores?.[selectedCard]}
            min={0}
            max={testOptions[selectedCard]?.maxScore}
            required={true}
            onChange={(val) =>
              setScores((prev) => ({
                ...(prev || {}),
                [selectedCard]: val,
              }))
            }
            size="small"
          />
        </>
      )}
    </Flex>
  );
};
